module.exports = __webpack_public_path__ + "static/img/bg_02.722229c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/bg_02.png
// module id = WwG1
// module chunks = 1